import { ISlice, ITextProcessor } from '../processor/constants'
import { getRangesIntersection } from '../processor/range'

export const decorate = (processor: ITextProcessor, slice: ISlice) => {
  const existingSlices = processor.getSlices().filter((s) => s.type === slice.type)

  for (const existingSlice of existingSlices) {
    const intersection = getRangesIntersection(existingSlice.range, slice.range)
    if (intersection) {
      processor.deleteSlice({ ...existingSlice, range: intersection })
    }
  }

  processor.insertSlice(slice)
}
